// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-page {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  margin: 2rem auto;
  max-width: 960px;
  box-shadow: var(--shadow);
}

.confirmation-header-banner {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: #ecfdf5;
  border: 1px solid #d1fae5;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
}

.confirmation-icon {
  color: var(--success-color);
  flex-shrink: 0;
}

.confirmation-header-banner h2 {
  margin-bottom: 0.25rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}

.confirmation-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.confirmation-card {
  background-color: #f8fafc;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 1rem;
}

.confirmation-card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--text-primary);
}

.confirmation-card-content h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 0.25rem;
}

.confirmation-card-content p {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.date-time-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.date-info,
.time-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-primary);
}

.comments-text {
  font-style: italic;
  color: var(--text-secondary);
}

.confirmation-procedures-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 1rem;
}

.confirmation-procedures-list li {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed var(--border-color);
  padding: 0.5rem 0;
  font-size: 0.875rem;
}

.procedure-price {
  color: var(--primary-color);
  font-weight: 600;
}

.confirmation-total-price {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 1rem;
  border-top: 1px solid var(--border-color);
  padding-top: 0.75rem;
}

.total-price-value {
  color: var(--primary-color);
  font-size: 1.125rem;
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

.confirm-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.confirm-button:hover {
  background-color: var(--primary-hover);
}

.back-button {
  border: 1px solid var(--border-color);
  background-color: transparent;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background-color 0.2s;
}

.back-button:hover {
  background-color: #f1f5f9;
}

@media (max-width: 768px) {
  .confirmation-details {
    grid-template-columns: 1fr;
  }

  .confirmation-actions {
    flex-direction: column;
    gap: 0.75rem;
  }

  .confirmation-actions button {
    width: 100%;
  }
}

/* Container principal da seção de confirmação */
.confirmation-content {
  max-width: 800px;
  margin: 0 auto;
  padding-top: 12px;
}

/* Seção de resumo */
.summary-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

/* Card principal que agrupa informações */
.summary-card-group {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease-in-out;
}

.summary-card-group:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* Linha individual dentro do card agrupado */
.summary-info-line {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
}

.summary-info-line:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.summary-info-line:first-child {
  padding-top: 0;
}

/* Ícones das linhas de informação */
.summary-info-line svg {
  flex-shrink: 0;
  color: #2563eb;
}

/* Linha especial para Data & Hora (com dois conjuntos de info) */
.summary-info-line.date-time-line {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Conteúdo das linhas - layout horizontal */
.summary-info-line > div {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.summary-info-line h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.summary-info-line p {
  margin: 0;
  font-size: 16px;
  color: #1f2937;
  line-height: 1.4;
}

/* Separador visual entre h4 e p */
.summary-info-line h4::after {
  content: ":";
  margin-left: 2px;
  color: #6b7280;
}

/* Para múltiplos parágrafos, adicionar separador */
.summary-info-line p + p::before {
  content: "•";
  margin: 0 8px;
  color: #6b7280;
}

/* Card individual para observações */
.summary-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease-in-out;
}

.summary-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.summary-card svg {
  color: #7c3aed;
  flex-shrink: 0;
  margin-top: 2px;
}

.summary-card > div {
  flex: 1 1;
}

.summary-card h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-card p {
  margin: 0 0 4px 0;
  font-size: 16px;
  color: #1f2937;
  line-height: 1.4;
}

.summary-card p:last-child {
  margin-bottom: 0;
}

/* Responsividade */
@media (max-width: 640px) {
  .confirmation-content {
    padding: 16px;
  }
  
  .summary-card-group,
  .summary-card {
    padding: 16px;
  }
  
  .summary-info-line {
    padding: 12px 0;
    flex-wrap: wrap;
  }
  
  /* Em telas pequenas, permitir quebra de linha se necessário */
  .summary-info-line > div {
    flex-wrap: wrap;
  }
  
  .summary-info-line h4 {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/confirmationPage.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,8DAA8D;EAC9D;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".confirmation-page {\n  background-color: white;\n  border-radius: 8px;\n  padding: 2rem;\n  margin: 2rem auto;\n  max-width: 960px;\n  box-shadow: var(--shadow);\n}\n\n.confirmation-header-banner {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: #ecfdf5;\n  border: 1px solid #d1fae5;\n  border-radius: 0.5rem;\n  margin-bottom: 2rem;\n}\n\n.confirmation-icon {\n  color: var(--success-color);\n  flex-shrink: 0;\n}\n\n.confirmation-header-banner h2 {\n  margin-bottom: 0.25rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.confirmation-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.confirmation-card {\n  background-color: #f8fafc;\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 1rem;\n}\n\n.confirmation-card-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  color: var(--text-primary);\n}\n\n.confirmation-card-content h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--primary-color);\n  margin-bottom: 0.25rem;\n}\n\n.confirmation-card-content p {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.date-time-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.date-info,\n.time-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n}\n\n.comments-text {\n  font-style: italic;\n  color: var(--text-secondary);\n}\n\n.confirmation-procedures-list {\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 1rem;\n}\n\n.confirmation-procedures-list li {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px dashed var(--border-color);\n  padding: 0.5rem 0;\n  font-size: 0.875rem;\n}\n\n.procedure-price {\n  color: var(--primary-color);\n  font-weight: 600;\n}\n\n.confirmation-total-price {\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n  font-size: 1rem;\n  border-top: 1px solid var(--border-color);\n  padding-top: 0.75rem;\n}\n\n.total-price-value {\n  color: var(--primary-color);\n  font-size: 1.125rem;\n}\n\n.confirmation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.confirm-button {\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.confirm-button:hover {\n  background-color: var(--primary-hover);\n}\n\n.back-button {\n  border: 1px solid var(--border-color);\n  background-color: transparent;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.back-button:hover {\n  background-color: #f1f5f9;\n}\n\n@media (max-width: 768px) {\n  .confirmation-details {\n    grid-template-columns: 1fr;\n  }\n\n  .confirmation-actions {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .confirmation-actions button {\n    width: 100%;\n  }\n}\n\n/* Container principal da seção de confirmação */\n.confirmation-content {\n  max-width: 800px;\n  margin: 0 auto;\n  padding-top: 12px;\n}\n\n/* Seção de resumo */\n.summary-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n/* Card principal que agrupa informações */\n.summary-card-group {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n  transition: all 0.2s ease-in-out;\n}\n\n.summary-card-group:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n/* Linha individual dentro do card agrupado */\n.summary-info-line {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.summary-info-line:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.summary-info-line:first-child {\n  padding-top: 0;\n}\n\n/* Ícones das linhas de informação */\n.summary-info-line svg {\n  flex-shrink: 0;\n  color: #2563eb;\n}\n\n/* Linha especial para Data & Hora (com dois conjuntos de info) */\n.summary-info-line.date-time-line {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Conteúdo das linhas - layout horizontal */\n.summary-info-line > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.summary-info-line h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.summary-info-line p {\n  margin: 0;\n  font-size: 16px;\n  color: #1f2937;\n  line-height: 1.4;\n}\n\n/* Separador visual entre h4 e p */\n.summary-info-line h4::after {\n  content: \":\";\n  margin-left: 2px;\n  color: #6b7280;\n}\n\n/* Para múltiplos parágrafos, adicionar separador */\n.summary-info-line p + p::before {\n  content: \"•\";\n  margin: 0 8px;\n  color: #6b7280;\n}\n\n/* Card individual para observações */\n.summary-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n  transition: all 0.2s ease-in-out;\n}\n\n.summary-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.summary-card svg {\n  color: #7c3aed;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.summary-card > div {\n  flex: 1;\n}\n\n.summary-card h4 {\n  margin: 0 0 8px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.summary-card p {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  color: #1f2937;\n  line-height: 1.4;\n}\n\n.summary-card p:last-child {\n  margin-bottom: 0;\n}\n\n/* Responsividade */\n@media (max-width: 640px) {\n  .confirmation-content {\n    padding: 16px;\n  }\n  \n  .summary-card-group,\n  .summary-card {\n    padding: 16px;\n  }\n  \n  .summary-info-line {\n    padding: 12px 0;\n    flex-wrap: wrap;\n  }\n  \n  /* Em telas pequenas, permitir quebra de linha se necessário */\n  .summary-info-line > div {\n    flex-wrap: wrap;\n  }\n  \n  .summary-info-line h4 {\n    white-space: normal;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
